import {
	IsBoolean,
	IsEnum,
	IsInt,
	IsOptional,
	IsString,
	MaxLength,
} from 'class-validator';
import type {
	EmailSharingRuleScope,
	EmailSharingRuleTargetType,
	EmailSharingRuleType,
} from '../entity';

// ============================================================================
// Email Sharing Rule DTOs
// ============================================================================

export class CreateEmailSharingRuleDto {
	@IsEnum(['global', 'connection'])
	public scope!: EmailSharingRuleScope;

	@IsInt()
	@IsOptional()
	public emailSourceId?: number | null;

	@IsEnum(['allow', 'block'])
	public ruleType!: EmailSharingRuleType;

	@IsEnum(['email_address', 'client', 'domain', 'all'])
	public targetType!: EmailSharingRuleTargetType;

	@IsString()
	@MaxLength(255)
	public targetValue!: string;

	@IsInt()
	@IsOptional()
	public targetClientId?: number | null;

	@IsBoolean()
	@IsOptional()
	public isOverride?: boolean;

	@IsString()
	@MaxLength(255)
	@IsOptional()
	public notes?: string | null;
}

export class UpdateEmailSharingRuleDto {
	@IsEnum(['allow', 'block'])
	@IsOptional()
	public ruleType?: EmailSharingRuleType;

	@IsEnum(['email_address', 'client', 'domain', 'all'])
	@IsOptional()
	public targetType?: EmailSharingRuleTargetType;

	@IsString()
	@MaxLength(255)
	@IsOptional()
	public targetValue?: string;

	@IsInt()
	@IsOptional()
	public targetClientId?: number | null;

	@IsBoolean()
	@IsOptional()
	public isOverride?: boolean;

	@IsString()
	@MaxLength(255)
	@IsOptional()
	public notes?: string | null;
}

export interface EmailSharingRuleDto {
	id: number;
	scope: EmailSharingRuleScope;
	emailSourceId: number | null;
	ruleType: EmailSharingRuleType;
	targetType: EmailSharingRuleTargetType;
	targetValue: string;
	targetClientId: number | null;
	targetClientName?: string | null;
	isOverride: boolean;
	createdByUserId: number;
	createdByUserName?: string | null;
	notes: string | null;
	createdDate: Date;
	modifiedDate: Date;
}

export interface GetEmailSharingRulesResponseDto {
	success: boolean;
	rules: Array<EmailSharingRuleDto>;
}

export interface CreateEmailSharingRuleResponseDto {
	success: boolean;
	rule: EmailSharingRuleDto;
}

export interface UpdateEmailSharingRuleResponseDto {
	success: boolean;
	rule: EmailSharingRuleDto;
}

export interface DeleteEmailSharingRuleResponseDto {
	success: boolean;
}

// ============================================================================
// Email Record Sharing Override DTOs
// ============================================================================

export class SetEmailSharingOverrideDto {
	@IsBoolean()
	public isShared!: boolean;
}

export interface EmailSharingOverrideDto {
	id: number;
	emailRecordId: string;
	isShared: boolean;
	setByUserId: number;
	setByUserName?: string | null;
	createdDate: Date;
	modifiedDate: Date;
}

export interface GetEmailSharingOverrideResponseDto {
	success: boolean;
	override: EmailSharingOverrideDto | null;
}

export interface SetEmailSharingOverrideResponseDto {
	success: boolean;
	override: EmailSharingOverrideDto;
}

export interface RemoveEmailSharingOverrideResponseDto {
	success: boolean;
}

// ============================================================================
// Email Sharing Evaluation DTOs
// ============================================================================

export interface EmailSharingEvaluationDto {
	isShared: boolean;
	reason: string;
	matchedRuleId?: number;
	matchedRuleType?: EmailSharingRuleType;
}
